// extracted by mini-css-extract-plugin
export var container = "_7t-0";
export var error = "_7t-9";
export var label = "_7t-5";
export var light = "_7t-6";
export var md = "_7t-3";
export var sm = "_7t-2";
export var thin = "_7t-8";
export var thinBold = "_7t-7";
export var vertical = "_7t-4";
export var xs = "_7t-1";